import * as React from 'react'

import { CSSProperties } from 'react'
import { ButtonOLD, ComplexCard } from '@lmc/ui-kit'
import dayjs from 'dayjs'

type NextReviewCardProps = {
  nextReviewDate?: string
  onReview?: () => void
  style: CSSProperties
  translate: (id: string, variable?: any) => string
}

export const NextReviewCard = ({
  nextReviewDate,
  onReview,
  style,
  translate,
}: NextReviewCardProps): React.ReactElement => (
  <ComplexCard
    localisation={{
      title: nextReviewDate
        ? translate('nextReview')
        : translate('noReviewSet'),
      review: translate('review'),
    }}
    dateValue={
      (nextReviewDate && dayjs(nextReviewDate).format('DD-MM-YYYY')) || ''
    }
    style={style as CSSProperties}
    rightChildren={
      !!onReview && (
        <ButtonOLD type="primary" onClick={onReview}>
          {translate('review')}
        </ButtonOLD>
      )
    }
  />
)

export default NextReviewCard
